@let pf = item().portfolioModel;
<fluent-card class="layout-hbox yearly-navigation" style="align-items: start; cursor: pointer" (click)="navigate($event, pf)" >
    <div class="uwy-and-period-header">
        {{pf.uwyear }}<br>
        {{pf.period}}
        <div class="open-hint">
            click to open
            @if (shiftKey()) { in new window }
            @else if (ctrlKey()) { in Tab }
        </div>
    </div>

    <div class="fullsize-vbox" style="font-size: 22px; flex: 1">
        <div style="font-weight: bold; display: none">
            {{ pf.phase }}
        </div>
        <div style="flex: 1; font-size: 12px; font-style: italic">{{ pf.description }}</div>
        <div>
            <!--
            <fluent-button style="white-space: nowrap; width: 100%">
                @if (shiftKey()) { New Window }
                @else if (ctrlKey()) { Open in Tab }
                @else { Open }
            </fluent-button>
            -->
        </div>
    </div>

    <div class="layout-vbox" style="width: 95px; align-items: center; align-self: flex-start; font-size: 16px;">
        <div class="layout-hbox">
            <div class="layout-vbox" style="align-items: flex-start; padding-left: 10px; padding-bottom: 10px">
                <div style="font-size: 20px">PLR</div>
                <div>{{ plr()| percent:'1.0-1' }}</div>
            </div>
            <div class="layout-vbox" style="align-items: flex-start; padding-left: 10px; padding-bottom: 10px">
                <div style="font-size: 20px">NLR</div>
                <div>{{ nlr()| percent:'1.0-1' }}</div>
            </div>
        </div>

        <wj-radial-gauge #g1 ngUniqueId style="width: 80px;" [isReadOnly]="true" [hasShadow]="false"
                         [value]="progress()" [showRanges]="true" [showText]="Wijmo.ShowText.Value">
            <wj-range [wjProperty]="'pointer'" [thickness]="0.5" [color]="GaugePointerColor"></wj-range>
            @for (range of GaugeMinMaxRanges; track range.min) {
                <wj-range [min]="range.min" [max]="range.max" [color]="range.color"></wj-range>
            })
        </wj-radial-gauge>

        <fluent-tooltip #tt [anchor]="g1.hostElement.id" positioning="after">
            @let sse = segmentStatusEntries();
            <table class="status-summary-table">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Open</td>
                        <td>{{sse[PortfolioStatisticStatusEnum.Open]}}</td>
                    </tr>
                    <tr>
                        <td>In local review</td>
                        <td>{{sse[PortfolioStatisticStatusEnum.InLocalReview]}}</td>
                    </tr>
                    <tr>
                        <td>In global review</td>
                        <td>{{sse[PortfolioStatisticStatusEnum.InGlobalReview]}}</td>
                    </tr>
                    <tr>
                        <td>Approved</td>
                        <td>{{sse[PortfolioStatisticStatusEnum.Approved]}}</td>
                    </tr>
                </tbody>
            </table>
        </fluent-tooltip>
    </div>
</fluent-card>
